var map = {
	"./dashboard.svg": 87532,
	"./example.svg": 30978,
	"./eye-open.svg": 35160,
	"./eye.svg": 97591,
	"./form.svg": 57610,
	"./link.svg": 62936,
	"./nested.svg": 92705,
	"./password.svg": 20731,
	"./table.svg": 19212,
	"./tree.svg": 91024,
	"./user.svg": 80681
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;